import React, {Component, isValidElement} from 'react';
import './maintenance-table-mobile.css';
import {connect} from 'react-redux';
import Utility from '../maintenance-table/utility';

class CourseMaintenanceTableMobile extends Component {
    constructor(props) {
        super(props);
        this.emptyMessage = props.emptyMessage;
        this.columns = props.columns;
        this.subCol = props.columns.filter((col)=> {
            return col.name === 'subjects'
        })[0];
    }

    getRecordIconClass(type) {
        switch (type && type.toLowerCase()) {
            case 'algebra':
                return 'subAlgebra';
            case 'us history':
            case 'u.s. history':
                return 'subUSHistory';
            case 'global history and geography':
                return 'subGlobHistory';
            case 'geometry':
                return 'subGeometry';
            case 'earth science':
                return 'subErthSci';
            case 'living environment':
                return 'subLivEnvi';
            default:
                return '';
        }
    }

    render() {
        let viewCourseMobile = this.props.viewCourseMobile;

        let records = <div className=" mobileListView hidden-lg hidden-tab hidden-md" key={'maintenance-table-mobile'}>
            {this.props.items.map((record, index) => {
                let name = record['courseName'] ? Utility.ucFirst(record['courseName']) : '';
                let ownerName = record['ownerName'] ? Utility.ucFirst(record['ownerName']) : '';
                let actClass = this.getRecordIconClass(record['subject']);
                let description = record['description'] ? Utility.ucFirst(record['description']) : '';
                return (<div key={index} className={"listviewblockBox " + actClass} onClick={()=>{viewCourseMobile(record)}}>
                        <div className="col-xs-2"><span className="typeIcon"/></div>
                        <div className="col-xs-10">
                          <span className="contentType ">
                            <h4>{name}</h4>
                            <p>By <strong>{ownerName}</strong></p>
                            <p>{description}</p>
                          </span>
                        </div>
                    </div>);
            })}
            {this.props.items.length === 0 ? <div className="listviewblockBox emptyMessage">
                {this.props.emptyMessage}
            </div> : null}
        </div>;
        return (records);
    }
}

function mapStateToProps(state = {}) {
    return {...state};
}
export default connect(mapStateToProps)(CourseMaintenanceTableMobile);
